export const managerCompletionStates = Object.freeze({ NONE: '확정 기록 없음', CONFIRMED: '수료 확정', REVOKED: '수료 취소', REVIEW_REQUIRED: '기록 검토 필요' })
export const managerCompletionLabel = value => managerCompletionStates[value] || '기록 확인 필요'
export const managerEnrollmentLabel = value => ({ ENROLLED: '입과', CANCELLED: '수강 취소', COMPLETED: '이관된 수강 완료' })[value] || '상태 확인 필요'
export const managerCompletionMessages = {
  B2B_COMPLETION_DENIED: '해당 기업·연수원의 수료 조회 권한과 기업 소속 기간을 확인해 주세요.',
  B2B_COMPLETION_FILTER_INVALID: '검색어·개설 번호·수료 상태를 확인해 주세요.',
}
